import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamation, faTriangle } from "@fortawesome/sharp-solid-svg-icons";

library.add(faTriangle, faExclamation);

export const ExclamationIcon = () => {
  return (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faTriangle} />
      <Box sx={[{ color: "header.main" }]}>
        <FontAwesomeIcon
          icon={faExclamation}
          transform="shrink-6 right-.5 down-1"
          data-testid="warning-icon"
        />
      </Box>
    </span>
  );
};
